export default __webpack_public_path__ + "static/media/litho-demo-magazine.5ef33887.jpg";